import { render } from "./AdminTable.vue?vue&type=template&id=deeeed38&scoped=true"
import script from "./AdminTable.vue?vue&type=script&lang=js"
export * from "./AdminTable.vue?vue&type=script&lang=js"

import "./AdminTable.vue?vue&type=style&index=0&id=deeeed38&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src141758530/src/mavent-project-vuejs-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deeeed38"]])

export default __exports__